import { LinkType } from "../../../sanity/lib/types/link";
import { LinkElement } from "../link/link";

export const PortableTextComponents = {
    types: {
        // internalLink: (props: { value: { language: string; code: string } }) => {
        //     const { language, code } = props.value;
        //     return (
        //         <pre data-language={language}>
        //             <code>{code}</code>
        //         </pre>
        //     );
        // },
    },
    marks: {
        internalLink: ({ value, children }: any) => {
            const { link = {} } = value;
            const href = `/${link}`;
            return <a href={href}>{children}</a>;
        },
        externalLink: ({ value, children }: any) => {
            const { weblink = "" } = value;
            const href = weblink;
            return (
                <a target="_blank" className="underline" href={href}>
                    {children}
                </a>
            );
        },
        link: ({ value, children }: any) => {
            const { blank, href } = value;
            return blank ? (
                <a href={href} target="_blank" rel="noopener">
                    {children}
                </a>
            ) : (
                <a href={href}>{children}</a>
            );
        },
    },
};
